// Add your custom JS here.
// Global variable to keep the player in
// So we can access it later if needed.
window.ytPlayer = null;

// Global event handler that the IFrame Player API will call once ready.
window.onYouTubeIframeAPIReady = () => {
  let playerElement = document.querySelector("#yt-embed-player");
  window.ytPlayer = new YT.Player('yt-embed-player', {
    // Video ID of the video we want to show. We will get this from data-id we set above
    videoId: playerElement.dataset.id,

    // Various settings and parameters for the player.
    // The required parameters for our purpose is: mute, loop and autoplay.
    // origin may be required for the player to work properly.
    playerVars: {
      controls: 0,
      showinfo: 0,
      modestbranding: 1,
      wmode: 'transparent',
      mute: 1,
      progressBar: false,
      loop: 1,
      rel: 0,
      autoplay: 1,
      origin: window.location.hostname
    },
    events: {
      // onReady() => called when the player is ready. Mute the video. It should already be muted, but this is just to make sure,
      // as the playerVars gets changed often.
      'onReady': (e) => { e.target.mute(); },

      // onStateChange => called whenever the video state changes. See the API Reference for the different states.
      // Play the video again when we detect that it has ended to loop.
      'onStateChange': (e) => {
        if (e.data === YT.PlayerState.ENDED) {
          e.target.playVideo();
        }
      },
    }
  })
}

jQuery(document).ready(function($) {
  const submenuSelector = '.submenu-productgroepen, .submenu-mega-assortiment';
  const menuItemSelector = 'nav .menu-item:has(.submenu-productgroepen), nav .menu-item:has(.submenu-mega-assortiment)';
  let wasMobile = window.innerWidth < 1200;

  function resetOpenMenuState() {
    $(submenuSelector).removeClass('open');
    $(menuItemSelector).removeClass('is-open');
  }

    // Alleen actief onder bepaalde schermbreedte (mobiel)
    function isMobile() {
      return window.innerWidth < 1200;
    }

    // Klikgedrag voor het specifieke menu-item
  $(menuItemSelector + ' > a').on('click', function(e) {
        if (isMobile()) {
            e.preventDefault(); // voorkomt directe navigatie
    const menuItem = $(this).closest('.menu-item');
      const submenu = $(this).siblings(submenuSelector);
    const isOpen = submenu.hasClass('open');

            // Sluit andere geopende submenu's
    resetOpenMenuState();

    if (!isOpen) {
      submenu.addClass('open');
      menuItem.addClass('is-open');
    }
        }
        else {
          e.preventDefault();
        }
    });

    // Optioneel: sluit submenu als er buiten geklikt wordt
    $(document).on('click', function(e) {
        if (isMobile()) {
        if (!$(e.target).closest(submenuSelector + ', ' + menuItemSelector).length) {
          resetOpenMenuState();
            }
        }
    });

    $(window).on('resize', function() {
      const nowMobile = isMobile();

      if (nowMobile !== wasMobile) {
        resetOpenMenuState();
        wasMobile = nowMobile;
      }
    });
});

document.addEventListener('DOMContentLoaded', function() {

  const searchWrapper = document.querySelector('.header-search');
  const toggle = document.querySelector('.search-toggle');
  const form = document.querySelector('.search-form');
  const input = document.querySelector('.search-field');

  if (!searchWrapper || !toggle || !form) return;

  // toggle open/dicht
  toggle.addEventListener('click', function(e) {
    e.preventDefault();
    searchWrapper.classList.toggle('active');

    if (searchWrapper.classList.contains('active')) {
      input.focus();
    }
  });

  // klik buiten formulier sluit veld
  document.addEventListener('click', function(e) {
    const isClickInside = searchWrapper.contains(e.target);
    if (!isClickInside && searchWrapper.classList.contains('active')) {
      searchWrapper.classList.remove('active');
    }
  });

  // sluit met Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchWrapper.classList.contains('active')) {
      searchWrapper.classList.remove('active');
    }
  });

});

(function() {
  'use strict';

  const PRODUCT_LIST_SELECTOR = '.woocommerce ul.products';
  const PRODUCT_CARD_SELECTOR = 'li.product';
  const PRODUCT_TITLE_SELECTOR = '.woocommerce-loop-product__title';

  const debounce = function(callback, delay) {
    let timeoutId;

    return function() {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(callback, delay);
    };
  };

  const alignProductCardTitlesByRow = function() {
    const productLists = document.querySelectorAll(PRODUCT_LIST_SELECTOR);

    productLists.forEach((list) => {
      const cards = Array.from(list.querySelectorAll(PRODUCT_CARD_SELECTOR));
      const titles = cards
        .map((card) => card.querySelector(PRODUCT_TITLE_SELECTOR))
        .filter(Boolean);

      titles.forEach((title) => {
        title.style.minHeight = '';
      });

      const rows = new Map();

      cards.forEach((card) => {
        const title = card.querySelector(PRODUCT_TITLE_SELECTOR);

        if (!title) {
          return;
        }

        const rowKey = Math.round(card.getBoundingClientRect().top);
        const rowTitles = rows.get(rowKey) || [];

        rowTitles.push(title);
        rows.set(rowKey, rowTitles);
      });

      rows.forEach((rowTitles) => {
        let maxHeight = 0;

        rowTitles.forEach((title) => {
          maxHeight = Math.max(maxHeight, title.offsetHeight);
        });

        rowTitles.forEach((title) => {
          title.style.minHeight = `${maxHeight}px`;
        });
      });
    });
  };

  const scheduleAlign = debounce(alignProductCardTitlesByRow, 120);

  document.addEventListener('DOMContentLoaded', alignProductCardTitlesByRow);
  window.addEventListener('load', alignProductCardTitlesByRow);
  window.addEventListener('resize', scheduleAlign);
  window.addEventListener('orientationchange', scheduleAlign);

  const observer = new MutationObserver(scheduleAlign);

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(PRODUCT_LIST_SELECTOR).forEach((list) => {
      observer.observe(list, { childList: true, subtree: true });
    });
  });
})();

(function() {
  'use strict';

  const config = window.BLDProductCompare || {};
  const storageKey = config.storageKey || 'bld_wc_compare_products';
  const maxItems = Number.parseInt(config.maxItems, 10) || 5;
  const compareUrl = config.compareUrl || '/vergelijken/';
  const restUrl = config.restUrl || '';
  const nonce = config.nonce || '';
  const showPrice = config.showPrice === true || config.showPrice === '1';

  const selectors = {
    productButton: '[data-bld-compare-product-id]',
    comparePage: '[data-bld-product-compare-page]',
    status: '[data-bld-compare-status]',
    table: '[data-bld-compare-table]',
    clear: '[data-bld-compare-clear]',
  };

  let compareBar = null;
  let compareBarCount = null;
  let compareBarMessage = null;

  const getStoredIds = function() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');

      if (!Array.isArray(parsed)) {
        return [];
      }

      return parsed
        .map((id) => Number.parseInt(id, 10))
        .filter((id, index, ids) => Number.isInteger(id) && id > 0 && ids.indexOf(id) === index)
        .slice(0, maxItems);
    } catch (error) {
      return [];
    }
  };

  const setStoredIds = function(ids) {
    const cleanIds = ids
      .map((id) => Number.parseInt(id, 10))
      .filter((id, index, currentIds) => Number.isInteger(id) && id > 0 && currentIds.indexOf(id) === index)
      .slice(0, maxItems);

    window.localStorage.setItem(storageKey, JSON.stringify(cleanIds));
    window.dispatchEvent(new CustomEvent('bldProductCompareUpdated', { detail: { ids: cleanIds } }));

    return cleanIds;
  };

  const createElement = function(tagName, className, text) {
    const element = document.createElement(tagName);

    if (className) {
      element.className = className;
    }

    if (typeof text === 'string') {
      element.textContent = text;
    }

    return element;
  };

  const appendButtonContent = function(button, iconClass, label) {
    const icon = createElement('span', `bld-wc-product-compare-action__icon ${iconClass}`);
    const labelElement = createElement('span', 'bld-wc-product-compare-action__label', label);

    icon.setAttribute('aria-hidden', 'true');

    button.append(icon, labelElement);
  };

  const appendIconButtonContent = function(button, iconClass) {
    const icon = createElement('span', `bld-wc-product-compare-action__icon ${iconClass}`);

    icon.setAttribute('aria-hidden', 'true');

    button.appendChild(icon);
  };

  const setMessage = function(message, type) {
    if (compareBarMessage) {
      compareBarMessage.textContent = message || '';
      compareBarMessage.dataset.state = type || '';
      compareBarMessage.hidden = !message;
    }
  };

  const setProductButtonLabel = function(button, label) {
    const labelElement = button.querySelector('.bld-wc-product-compare-button__label');

    if (labelElement) {
      labelElement.textContent = label;
      return;
    }

    button.textContent = label;
  };

  const updateProductButtons = function() {
    const ids = getStoredIds();

    document.querySelectorAll(selectors.productButton).forEach((button) => {
      const productId = Number.parseInt(button.dataset.bldCompareProductId, 10);
      const isAdded = ids.includes(productId);

      button.classList.remove('is-empty', 'is-added', 'is-go-to-compare', 'is-max-reached');

      if (!isAdded) {
        setProductButtonLabel(button, 'Vergelijk product');
        button.classList.add(ids.length >= maxItems ? 'is-max-reached' : 'is-empty');
        return;
      }

      setProductButtonLabel(button, 'Naar vergelijking');
      button.classList.add('is-added', 'is-go-to-compare');
    });
  };

  const updateCompareBar = function() {
    const ids = getStoredIds();

    if (!compareBar) {
      return;
    }

    compareBar.hidden = ids.length < 1;
    compareBar.classList.toggle('is-visible', ids.length > 0);
    compareBar.classList.toggle('is-empty', ids.length < 1);

    if (compareBarCount) {
      compareBarCount.textContent = ids.length === 1 ? '1 product in vergelijking' : `${ids.length} producten in vergelijking`;
    }
  };

  const syncUi = function() {
    updateProductButtons();
    updateCompareBar();
  };

  const addProduct = function(productId) {
    const ids = getStoredIds();

    if (ids.includes(productId)) {
      syncUi();
      return;
    }

    if (ids.length >= maxItems) {
      setMessage(`Je kunt maximaal ${maxItems} producten vergelijken.`, 'error');
      updateProductButtons();
      return;
    }

    setStoredIds(ids.concat(productId));
    setMessage('Product toegevoegd aan de vergelijking.', 'success');
    syncUi();
  };

  const removeProduct = function(productId) {
    setStoredIds(getStoredIds().filter((id) => id !== productId));
    setMessage('Product verwijderd uit de vergelijking.', 'success');
    syncUi();
    renderComparePage();
  };

  const clearProducts = function() {
    setStoredIds([]);
    setMessage('Vergelijker leeggemaakt.', 'success');
    syncUi();
    renderComparePage();
  };

  const buildCompareBar = function() {
    compareBar = createElement('div', 'bld-wc-product-compare-bar is-empty');
    compareBar.hidden = true;
    compareBar.setAttribute('role', 'region');
    compareBar.setAttribute('aria-label', 'Productvergelijker');

    compareBarCount = createElement('span', 'bld-wc-product-compare-bar__count');
    compareBarMessage = createElement('span', 'bld-wc-product-compare-bar__message');
    compareBarMessage.hidden = true;

    const goButton = createElement('a', 'btn btn-secondary bld-wc-product-compare-bar__button');
    goButton.href = compareUrl;
    appendButtonContent(goButton, 'is-arrow', 'Naar vergelijking');

    compareBar.append(compareBarCount, goButton, compareBarMessage);
    document.body.appendChild(compareBar);
  };

  const bindProductButtons = function() {
    document.querySelectorAll(selectors.productButton).forEach((button) => {
      button.addEventListener('click', () => {
        const productId = Number.parseInt(button.dataset.bldCompareProductId, 10);
        const ids = getStoredIds();

        if (!Number.isInteger(productId) || productId < 1) {
          return;
        }

        if (ids.includes(productId)) {
          window.location.href = compareUrl;
          return;
        }

        addProduct(productId);
      });
    });
  };

  const setComparePageStatus = function(page, message) {
    const status = page.querySelector(selectors.status);

    if (status) {
      status.textContent = message || '';
    }
  };

  const renderEmptyComparePage = function(page) {
    const tableWrap = page.querySelector(selectors.table);
    const clearButton = page.querySelector(selectors.clear);

    if (tableWrap) {
      tableWrap.replaceChildren(createElement('p', 'bld-wc-product-compare-empty', 'Er zijn nog geen producten toegevoegd aan de vergelijking.'));
    }

    if (clearButton) {
      clearButton.hidden = true;
    }

    setComparePageStatus(page, '');
  };

  const createTableCell = function(tagName, text) {
    const cell = document.createElement(tagName);
    cell.textContent = text || '-';

    return cell;
  };

  const normalizeCompareValue = function(value) {
    return String(value || '-').trim().replace(/\s+/g, ' ').toLowerCase();
  };

  const rowHasDifferences = function(values) {
    const normalizedValues = values.map(normalizeCompareValue);

    return new Set(normalizedValues).size > 1;
  };

  const markDifferenceRow = function(row, values) {
    row.classList.toggle('has-differences', rowHasDifferences(values));
  };

  const renderCompareTable = function(page, data) {
    const tableWrap = page.querySelector(selectors.table);
    const clearButton = page.querySelector(selectors.clear);
    const products = Array.isArray(data.products) ? data.products : [];
    const rows = Array.isArray(data.rows) ? data.rows : [];

    if (!tableWrap) {
      return;
    }

    if (products.length < 1) {
      renderEmptyComparePage(page);
      return;
    }

    const table = createElement('table', 'bld-wc-product-compare-table');
    const thead = document.createElement('thead');
    const tbody = document.createElement('tbody');
    const headerRow = document.createElement('tr');

    headerRow.appendChild(createTableCell('th', 'Eigenschap'));

    products.forEach((product) => {
      const th = document.createElement('th');
      const link = createElement('a', 'bld-wc-product-compare-table__product-link');
      link.href = product.permalink || '#';

      const image = document.createElement('img');
      image.src = product.image || '';
      image.alt = product.imageAlt || product.title || '';
      image.loading = 'lazy';

      const title = createElement('span', 'bld-wc-product-compare-table__title', product.title || '-');
      const removeButton = createElement('button', 'btn btn-link bld-wc-product-compare-table__remove');
      removeButton.type = 'button';
      removeButton.title = 'Product verwijderen';
      removeButton.setAttribute('aria-label', 'Product verwijderen');
      removeButton.dataset.bldCompareRemoveId = String(product.id);
      appendIconButtonContent(removeButton, 'is-remove');
      removeButton.addEventListener('click', () => removeProduct(Number.parseInt(product.id, 10)));

      link.append(image, title);
      th.append(removeButton, link);
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);

    if (showPrice) {
      const priceRow = document.createElement('tr');
      const priceValues = products.map((product) => product.price || '-');
      markDifferenceRow(priceRow, priceValues);
      priceRow.appendChild(createTableCell('th', 'Prijs'));
      priceValues.forEach((price) => {
        priceRow.appendChild(createTableCell('td', price));
      });
      tbody.appendChild(priceRow);
    }

    rows.forEach((row) => {
      const tr = document.createElement('tr');
      const rowValues = products.map((product) => {
        const attributes = product.attributes || {};
        const attribute = attributes[row.key] || null;

        return attribute && attribute.value ? attribute.value : '-';
      });

      markDifferenceRow(tr, rowValues);
      tr.appendChild(createTableCell('th', row.label || '-'));

      rowValues.forEach((value) => {
        tr.appendChild(createTableCell('td', value));
      });

      tbody.appendChild(tr);
    });

    table.append(thead, tbody);
    tableWrap.replaceChildren(table);

    if (clearButton) {
      clearButton.hidden = false;
    }

    setComparePageStatus(page, '');
  };

  const renderComparePage = function() {
    const page = document.querySelector(selectors.comparePage);

    if (!page) {
      return;
    }

    const ids = getStoredIds();

    if (ids.length < 1) {
      renderEmptyComparePage(page);
      return;
    }

    if (!restUrl) {
      setComparePageStatus(page, 'De productdata kan niet worden opgehaald.');
      return;
    }

    setComparePageStatus(page, 'Producten laden...');

    const url = new URL(restUrl);
    url.searchParams.set('ids', ids.join(','));

    window.fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-WP-Nonce': nonce,
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('REST request failed');
        }

        return response.json();
      })
      .then((data) => renderCompareTable(page, data))
      .catch(() => {
        setComparePageStatus(page, 'De vergelijking kon niet worden geladen.');
      });
  };

  const bindComparePage = function() {
    const page = document.querySelector(selectors.comparePage);

    if (!page) {
      return;
    }

    const clearButton = page.querySelector(selectors.clear);

    if (clearButton) {
      clearButton.addEventListener('click', clearProducts);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    buildCompareBar();
    bindProductButtons();
    bindComparePage();
    syncUi();
    renderComparePage();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) {
      syncUi();
      renderComparePage();
    }
  });

  window.addEventListener('bldProductCompareUpdated', () => {
    syncUi();
  });
})();
